/* Shopify-bound pouch builder. Deliberately scoped to the frozen landing sections. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.lzfInitialized) return;
    const dataNode = root.querySelector('[data-lzf-data]');
    if (!dataNode) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
    if (!Array.isArray(data.products) || !data.products.length) return;
    root.dataset.lzfInitialized = 'true';
    const form = root.querySelector('.lzf-builder-form');
    const slots = [...root.querySelectorAll('[data-slot]')];
    const add = root.querySelector('[data-add]');
    const error = root.querySelector('[data-error]');
    const success = root.querySelector('[data-success]');
    const rootPath = (data.root || '/').replace(/\/?$/, '/');
    let count = Number(root.querySelector('[name^="lzf-pack-"]:checked')?.value || 2);
    let busy = false;
    // Product-page views start with the SKU the shopper deliberately opened.
    // The dedicated landing page has no initialVariantId and keeps its defaults.
    const initial = data.products.find(item => String(item.id) === String(data.initialVariantId));
    if (initial) {
      slots[0].querySelector('[data-formula]').value = initial.formula;
      slots[0].querySelector('[data-flavor]').value = initial.flavor;
      slots[1].querySelector('[data-formula]').value = initial.formula;
      slots[1].querySelector('[data-flavor]').value = initial.flavor === 'lime' ? 'strawberry' : 'lime';
    }
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: data.currency || 'USD'
    }).format(Number(cents) / 100);
    const selected = slot => data.products.find(product =>
      product.formula === slot.querySelector('[data-formula]').value &&
      product.flavor === slot.querySelector('[data-flavor]').value
    );
    function render() {
      const selection = [];
      slots.forEach((slot, index) => {
        const enabled = index < count;
        slot.hidden = !enabled;
        slot.disabled = !enabled;
        const product = selected(slot);
        const input = slot.querySelector('[data-variant]');
        input.value = product?.id || '';
        const title = slot.querySelector('[data-pouch-title]');
        const price = slot.querySelector('[data-pouch-price]');
        const sweetener = slot.querySelector('[data-pouch-sweetener]');
        const image = slot.querySelector('[data-pouch-image]');
        const link = slot.querySelector('[data-product-link]');
        title.textContent = product?.title || data.labels.unavailable;
        if (sweetener) {
          const formula = product?.formula || slot.querySelector('[data-formula]').value;
          sweetener.textContent = product ? (String(formula).toLowerCase().includes('cheat') ? 'Sweetened with cane sugar + allulose' : 'Sweetened with our zero-calorie allulose blend') : '';
          sweetener.hidden = !product;
        }
        price.textContent = product ? money(product.price) : '';
        image.hidden = !product?.image;
        if (product?.image) { image.src = product.image; image.alt = `${product.title} pouch`; }
        link.hidden = !product;
        if (product) {
          link.href = product.url;
          link.setAttribute('aria-label', `${link.textContent}: ${product.title}`);
        }
        slot.querySelector('[data-pouch-availability]').textContent = !product
          ? data.labels.unavailable : (!product.available ? data.labels.soldOut : '');
        if (enabled) selection.push(product);
      });
      const total = selection.reduce((sum, product) => sum + (product?.price || 0), 0);
      root.querySelector('[data-total]').textContent = money(total);
      const priceOne = root.querySelector('[data-pack-price="1"]');
      const priceTwo = root.querySelector('[data-pack-price="2"]');
      if (priceOne && data.products.length) priceOne.textContent = money(selected(slots[0])?.price ?? data.products[0].price);
      if (priceTwo && data.products.length) {
        const first = selected(slots[0]);
        const second = selected(slots[1]);
        priceTwo.textContent = first && second ? money(first.price + second.price) : 'Select flavors';
      }
      root.querySelector('[data-yield]').textContent = count === 2 ? data.labels.yieldTwo : data.labels.yieldOne;
      root.querySelector('[data-shipping]').textContent = selection.some(product => !product)
        ? 'Select an available formula and flavor to see shipping'
        : total >= data.threshold
          ? `Free shipping · ${money(total)} before tax`
          : `${money(total)} + $6 flat-rate shipping = ${money(total + 600)} before tax`;
      add.disabled = busy || selection.some(product => !product || !product.available);
      add.textContent = busy ? data.labels.adding
        : `${count === 2 ? data.labels.addTwo : data.labels.addOne} · ${money(total)}`;
      return selection;
    }
    root.querySelectorAll('[name^="lzf-pack-"]').forEach(input => input.addEventListener('change', () => {
      count = Number(input.value);
      error.hidden = true;
      success.hidden = true;
      render();
    }));
    slots.forEach(slot => slot.querySelectorAll('select').forEach(select => select.addEventListener('change', () => {
      error.hidden = true;
      success.hidden = true;
      render();
    })));
    async function refreshNativeCart() {
      const response = await fetch(`${rootPath}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart refresh failed');
      const cart = await response.json();
      document.querySelectorAll('.js-cart-count').forEach(element => {
        element.textContent = element.textContent.trim().startsWith('(')
          ? `(${cart.item_count})` : String(cart.item_count);
      });
      if (window.theme?.miniCart) {
        try {
          window.theme.miniCart.generateCart();
          // The native updateElements opens the drawer whenever the cart has items.
          // Refresh its other responsibilities without changing drawer visibility.
          document.querySelectorAll('.js-cart-total').forEach(element => {
            element.textContent = money(cart.total_price);
          });
          document.querySelectorAll('.js-cart-btn-checkout').forEach(element => {
            element.classList.toggle('disabled', cart.item_count === 0);
          });
          if (window.theme.freeShipping?.load) window.theme.freeShipping.load(cart);
        } catch (_) { /* Same-page confirmation and normal cart link remain available. */ }
      }
      root.querySelector('[data-cart-summary]').textContent =
        `${data.labels.cartPrefix} ${cart.item_count} ${data.labels.itemsLabel} · ${money(cart.total_price)}`;
      return cart;
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const selection = render();
      if (selection.length !== count || selection.some(product => !product?.available)) {
        error.textContent = data.labels.unavailable;
        error.hidden = false;
        return;
      }
      // Aggregate repeated choices into one quantity so same-flavor packs remain truthful.
      const quantities = new Map();
      selection.forEach(product => quantities.set(product.id, (quantities.get(product.id) || 0) + 1));
      const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
      busy = true;
      error.hidden = true;
      success.hidden = true;
      form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('select').forEach(element => { element.disabled = true; });
      root.querySelectorAll('[name^="lzf-pack-"]').forEach(element => { element.disabled = true; });
      render();
      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          const failure = new Error(response.status === 422
            ? (result.description || result.message || data.labels.retryError)
            : data.labels.retryError);
          failure.displayMessage = failure.message;
          throw failure;
        }
        root.querySelector('[data-success-message]').textContent = '';
        root.querySelector('[data-cart-summary]').textContent = '';
        success.hidden = false;
        requestAnimationFrame(() => {
          root.querySelector('[data-success-message]').textContent = data.labels.success;
        });
        let cart = null;
        try { cart = await refreshNativeCart(); } catch (_) {
          root.querySelector('[data-cart-summary]').textContent = data.labels.cartRefreshError;
        }
        document.dispatchEvent(new CustomEvent('cart:add', { detail: { items, cart, source: 'liquidzero-frozen-builder' } }));
        document.dispatchEvent(new CustomEvent('liquidzero:cart-added', { detail: { items, cart, source: 'liquidzero-frozen-builder' } }));
        // Standard Shopify cart requests remain the primary pixel source. This event is
        // custom, explicitly named, and does not impersonate standard analytics events.
        if (window.Shopify?.analytics?.publish) {
          try {
            window.Shopify.analytics.publish('liquidzero_frozen_pack_added', {
              items, pouch_count: count, value: selection.reduce((sum, p) => sum + p.price, 0) / 100,
              currency: data.currency
            });
          } catch (_) { /* Analytics cannot prevent a completed cart addition. */ }
        }
      } catch (failure) {
        error.textContent = failure.displayMessage || data.labels.retryError;
        error.hidden = false;
      } finally {
        busy = false;
        form.removeAttribute('aria-busy');
        form.querySelectorAll('select').forEach(element => { element.disabled = false; });
        root.querySelectorAll('[name^="lzf-pack-"]').forEach(element => { element.disabled = false; });
        render();
      }
    });
    render();
    root.querySelector('.lzf-interactive').hidden = false;
    root.querySelector('.lzf-fallback').hidden = true;
    if (root.closest('.lzf-pdp-builder')) {
      const stickyChooser = document.querySelector('#js-sticky-btn[href="#buy"]');
      if (stickyChooser) stickyChooser.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        // Use scroll-margin rather than the theme's unoffset jQuery anchor jump.
        root.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
    document.addEventListener('shopify:block:select', event => {
      const product = data.products.find(item => item.blockId === event.detail?.blockId);
      if (!product) return;
      const slot = slots[0];
      slot.querySelector('[data-formula]').value = product.formula;
      slot.querySelector('[data-flavor]').value = product.flavor;
      render();
      slot.scrollIntoView({ behavior: 'auto', block: 'center' });
    });
  }
  function scan(scope = document) { scope.querySelectorAll('[data-lzf-builder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
